"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterType = void 0;
var MeterType;
(function (MeterType) {
    MeterType["CONVENTIONAL"] = "CVN";
    MeterType["SMART"] = "SLM";
    MeterType["READABLE_FROM_DISTANCE_BUT_NOT_TOGGLEABLE"] = "DUN";
    MeterType["READABLE_FROM_DISTANCE_AND_TOGGLEABLE"] = "DUS";
    MeterType["DAILY_REMOTE_READABLE"] = "M01";
    MeterType["OTHER"] = "M02";
})(MeterType = exports.MeterType || (exports.MeterType = {}));
